import { TreeSelect, TreeSelectProps } from 'antd-v5';
import styled, { createGlobalStyle } from 'styled-components';
import { TREE_SELECT_ZINDEX } from 'styles';

export const TreeSelectStyles = createGlobalStyle`
    .custom-select-tree-dropdown .ant5-select-tree-switcher.ant5-select-tree-switcher-noop {
        width: 0px !important;
        padding-left: 10px !important;
    }

    .custom-select-tree-dropdown {
        z-index: ${TREE_SELECT_ZINDEX};
    }
`;

export const STreeSelect = styled(TreeSelect)<TreeSelectProps>`
  height: 40px;
  min-width: 300px;
`;
